import DemoModeInfo from './DemoModeInfo'
export default DemoModeInfo
